/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ai-usage.vue?vue&type=template&id=8651f8ac&scoped=true&"
import script from "./ai-usage.vue?vue&type=script&lang=js&"
export * from "./ai-usage.vue?vue&type=script&lang=js&"
import style0 from "./ai-usage.vue?vue&type=style&index=0&id=8651f8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8651f8ac",
  null
  
)

export default component.exports